import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["add", "addhere", "template", "order"]

  add_associations(event) {
    event.preventDefault()
    let content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().valueOf())
    this.addhereTarget.insertAdjacentHTML('beforebegin', content)
    $(this.addTarget).remove()
  }

  add_associations_with_order(event) {
    this.add_associations(event)

    if (this.orderTargets.length > 0) {
      let index = 0
      this.orderTargets.forEach((el, i) => {
        if (!$(el).is(":hidden")) {
          index += 1
          el.value = index
        }
      })
    }

  }
}
